import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingCheckout: false,
  checkoutData: null,
  errorCheckout: null,

  loadingPublicStkPush: false,
  publicStkPushSuccess: false,
  errorPublicStkPush: null,
};

const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    // Checkout Details
    setLoadingCheckout: (state) => {
      state.loadingCheckout = true;
      state.errorCheckout = null;
    },
    setCheckoutData: (state, action) => {
      state.loadingCheckout = false;
      state.checkoutData = action.payload;
    },
    setErrorCheckout: (state, action) => {
      state.loadingCheckout = false;
      state.errorCheckout = action.payload;
    },

    // Public STK Push
    setLoadingPublicStkPush: (state) => {
      state.loadingPublicStkPush = true;
      state.errorPublicStkPush = null;
      state.publicStkPushSuccess = false;
    },
    setPublicStkPushSuccess: (state) => {
      state.loadingPublicStkPush = false;
      state.publicStkPushSuccess = true;
    },
    setErrorPublicStkPush: (state, action) => {
      state.loadingPublicStkPush = false;
      state.errorPublicStkPush = action.payload;
    },
    resetPublicStkPushState: (state) => {
      state.publicStkPushSuccess = false;
      state.errorPublicStkPush = null;
    },
  },
});

export const {
  setLoadingCheckout,
  setCheckoutData,
  setErrorCheckout,
  setLoadingPublicStkPush,
  setPublicStkPushSuccess,
  setErrorPublicStkPush,
  resetPublicStkPushState,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
